import React, { useRef } from 'react';
import heroPhoto from '../../../assets/site/hero-city.jpg';
import heroVideo from '../../../assets/site/hero-timelapse.mp4';
import Section from '../../site/components/Section';
import { contact } from '../../site/data/contact';
import cx from '../../site/utils/cx';
import ui from '../../site/styles/primitives.module.css';
import HoloScene from './HoloScene';
import useHeroVideo from './useHeroVideo';
import styles from './Hero.module.css';

const Hero = () => {
  const videoRef = useRef(null);
  const videoPlaying = useHeroVideo(videoRef);

  return (
    <Section id="top" overlay="hero" className={cx(styles.hero, videoPlaying && styles.videoOn)}>
      <div className={styles.photo} style={{ backgroundImage: `url(${heroPhoto})` }} aria-hidden="true" />
      <video
        ref={videoRef}
        className={styles.video}
        src={heroVideo}
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
        tabIndex={-1}
      />

      <div className={cx(ui.wrap, styles.grid)}>
        <div data-reveal="">
          <span className={ui.eyebrow}>Real estate investment</span>
          <h1 className={styles.title}>
            Building wealth. <span className={ui.grad}>Rebuilding cities.</span>
          </h1>
          <p className={styles.lede}>
            DS360 Investment partners with investors to acquire, develop and revitalize real estate, creating lasting
            value for our clients and for the communities we build in.
          </p>
          <div className={styles.actions}>
            <a className={cx(ui.btn, ui.btnPrimary)} href="#invest">
              Invest with DS360
            </a>
            <a className={cx(ui.btn, ui.btnGhost)} href="#call">
              Schedule a call
            </a>
            <a className={cx(ui.btn, ui.btnGhost)} href={contact.instagramUrl} target="_blank" rel="noopener noreferrer">
              Join DS360 today <span aria-hidden="true">↗</span>
              <span className={ui.srOnly}> (opens Instagram in a new tab)</span>
            </a>
          </div>
        </div>

        <div className={styles.scene} data-reveal="">
          <HoloScene />
        </div>
      </div>
    </Section>
  );
};

export default Hero;
